import { QueryClient } from "@tanstack/react-query";
import { OperationClient } from "../../../../api/api";
import { DomainServiceOperationCallExpression } from "../../../Models/DomainServices/DomainServiceOperationCallExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export type ApiServices = {
  operationClient: OperationClient;
  queryClient: QueryClient;
  errorHandler: (error: any) => void;
};

export const ApiServicesKey = "ApiServices";

export class DomainServiceOperationCallExpressionEvaluator implements IExpressionEvaluator<DomainServiceOperationCallExpression> {
  get type(): string {
    return "DomainService.OperationCall";
  }

  private static DefaultStaleTime = 10000;

  private logTransformed(result: any): any {
    console.log("[DomainServiceOperationCallExpressionEvaluator] Transformed response:", result);
    return result;
  }

  private applyResponseTransform(response: any, expression: DomainServiceOperationCallExpression, context: IExpressionEvaluatorContext): MaybePromise {
    if (!expression.ResponseTransform) {
      return response;
    }

    const transformContext = context.CreateChild();
    transformContext.VariableScope.set("$source", response);

    const transformed = context.Evaluator.evaluate(expression.ResponseTransform, transformContext);

    if (transformed instanceof Promise) {
      return transformed.then((result) => this.logTransformed(result));
    }

    return this.logTransformed(transformed);
  }

  async evaluate(expression: DomainServiceOperationCallExpression, context: IExpressionEvaluatorContext): Promise<any> {
    const { operationClient, queryClient, errorHandler } = context.GetProperty<ApiServices>(ApiServicesKey);

    try {
      const request = await context.Evaluator.evaluate(expression.Request, context);
      const response = await queryClient.fetchQuery({
        queryKey: ["DomainServiceOperation", expression.Operation.Id, request],
        queryFn: () => operationClient.execute(expression.Operation.Id, expression.Operation.Name, "00000000-0000-0000-0000-000000000000", request),
        //staleTime: DomainServiceOperationCallExpressionEvaluator.DefaultStaleTime,
        staleTime: 0,
      });
      console.log("[DomainServiceOperationCallExpressionEvaluator] response:", response);

      const responseTransformed = await this.applyResponseTransform(response, expression, context);

      if (expression.ResponseVariable) {
        context.Evaluator.assign(expression.ResponseVariable, context, responseTransformed);
      }

      return responseTransformed;
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  }
}
